import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ja from 'vuetify/lib/locale/ja';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#0075c2',
        secondary: '#37a34a',
        accent: '#fcc800',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#e63e46',
        lightBlue: '#dbe2f3',
      },
    },
  },
  lang: {
    locales: { ja },
    current: 'ja',
  },
});
